import React from "react";
import { MenuItem } from "components/bootstrap";
const StreamCategoriesAction = ({ modalRef, entity }) => {
  if (!entity.is_editable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  } }, "Manage Categories");
};
export default StreamCategoriesAction;
